import { Controller } from "@hotwired/stimulus"

// Highlights the currently selected employee in the directory list. Clicking a row only
// swaps the detail (`employee`) turbo frame, not the list, so the active state is tracked
// client-side here. `itemTargetConnected` re-applies it when the list frame re-renders
// (search/filter/sort).
export default class extends Controller {
  static targets = ["item"]
  static values = { activeId: String }

  static activeClasses = ["bg-green-50", "border-green-500"]

  select(event) {
    const item = event.currentTarget.closest("[data-employee-id]")
    if (!item) return
    // Apply synchronously for instant feedback. Setting activeIdValue alone defers the
    // visual update to the async value-changed callback, which lags behind the click.
    this.activeIdValue = item.dataset.employeeId
    this.itemTargets.forEach((target) => this.apply(target))
  }

  activeIdValueChanged() {
    this.itemTargets.forEach((item) => this.apply(item))
  }

  itemTargetConnected(item) {
    this.apply(item)
  }

  apply(item) {
    const active = item.dataset.employeeId === this.activeIdValue
    this.constructor.activeClasses.forEach((cls) => item.classList.toggle(cls, active))
    item.classList.toggle("border-transparent", !active)
  }
}
